export const USER_CONSTANT = {
  USER_DATA: "/user",
  GET_USER_INFO: "/user/userDetails",
  CHANGE_PASSWORD: "/user/password",
  USER_BY_ROLE: "/user/role/oadmin",
  USER_BY_OFFICE: "/user/oadmin/list",
  ASSIGN_AS_ADMIN: "/user/assignadmin",
  USER_SUPPORTED_LANG: "/supported-language",
  ACTIVATE_SUPPORTED_LANG: "/supported-language/setActive",
};
